import React, {
	createContext,
	type ComponentType,
	type ReactNode,
} from "react";
import type { NavbarRendererProps } from "./components/navigation/NavbarMenuBar";
import { ConfigurationsType } from "./configurationMenu";

const RouterContext = createContext<() => ReactNode>(() => <></>);
const ConfigurationContext = createContext<ConfigurationsType>([
	[],
	() => <></>,
]);
const NavbarContext = createContext<ComponentType<NavbarRendererProps>>(() => (
	<></>
));
const OperatorsFeatureContext = createContext<boolean>(false);
const EmailTopicsFeatureContext = createContext<boolean>(false);

export {
	RouterContext,
	ConfigurationContext,
	NavbarContext,
	OperatorsFeatureContext,
	EmailTopicsFeatureContext,
};
